import { BaseFormatEvent } from 'common/event-handling/base-format-event.model';

export class OcsPreloadedEvent extends BaseFormatEvent {
  constructor() {
    super('ocs-preloaded');
  }
}
